import ReportKidSnapshotViewContainer from './ReportKidSnapshotViewContainer';
export default ReportKidSnapshotViewContainer;
